/* Copyright (c) 2019 VMware, Inc. All rights reserved. VMware Confidential */
export class Event {
    constructor(public id: string) {
    }
}
